import { render, staticRenderFns } from "./HeadOrderTab.vue?vue&type=template&id=3db9ffd2&scoped=true&lang=pug"
import script from "./HeadOrderTab.vue?vue&type=script&lang=js"
export * from "./HeadOrderTab.vue?vue&type=script&lang=js"
import style0 from "./HeadOrderTab.vue?vue&type=style&index=0&id=3db9ffd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3db9ffd2",
  null
  
)

export default component.exports